import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';
import ScrollAnimation from 'react-animate-on-scroll';

class AboutV4 extends Component {

    render() {

        let publicUrl = process.env.PUBLIC_URL+'/'

    return <div className="about-area pd-top-100 pd-bottom-100" style={{backgroundImage: 'url("'+publicUrl+'assets/img/bg/2.png")'}}>
			  <div className="container">
			    <div className="about-area-inner">
			      <div className="row">
			        <div className="col-lg-6 order-lg-12 align-self-center">
						<ScrollAnimation animateIn="fadeInRight">
			          		<img src={publicUrl+"assets/img/website/chairman.jpg"} alt="img" style={{borderRadius:'50%'}} />
						</ScrollAnimation>	
			        </div>
			        <div className="col-lg-6 order-lg-1 align-self-center mt-4 mt-lg-0">
			          <div className="about-inner-wrap">  
			            <div className="section-title mb-0">
							<ScrollAnimation animateIn="fadeInLeft">
								<h5 className='courHeading' style={{textAlign:'left'}}><Link to="/">Chairman's Message</Link></h5>
							</ScrollAnimation>
							<ScrollAnimation animateIn="fadeInLeft">
								<h2 className="title">Dr. T M GUNARAJA</h2>
								<p>F.I.E., Ph.D</p>
							</ScrollAnimation>
							<ScrollAnimation animateIn="fadeInLeft">
								<p className="content">MIET was incepted with the challenging principal notion “VALUE LEARNING FOR ALL”. We started with the mission to promote quality, technical and engineering education thus promoting the professionalism of those engaged in the pursuits, followed by expanding our origin in to Arts & Science graduation courses. We take high privilege to share that we stand out of the crowd by serving the deprived student community with quality education at an economical budget. Our student centered approach and individual attention made us to witness transformations in our student’s lives at all times.</p>
							</ScrollAnimation>
			            </div>
			          </div>
			        </div>
			      </div>
			    </div>
			  </div>
			</div>
        }
}

export default AboutV4